export default {
  lang: 'sk',
  dir: 'ltr',
  common: {
    ok: 'Uložiť',
    cancel: 'Zrušiť',
    key_backspace: 'Backspace',
    key_del: 'Delete',
    key_down: 'šípka dole',
    key_up: 'šípka hore',
    more_opts: 'Viac možností',
    url: 'URL',
    width: 'Šírka',
    height: 'Výška'
  },
  misc: {
    powered_by: 'Beží na'
  },
  ui: {
    toggle_stroke_tools: 'Skryť/ukázať viac nástrojov pre krivku',
    palette_info: 'Kliknutím zmeníte farbu výplne, so Shiftom zmeníte farbu obrysu',
    zoom_level: 'Zmena priblíženia',
    panel_action: 'Click to open side panel',
    quality: 'Quality:',
    pathNodeTooltip: 'Drag node to move it. Double-click node to change segment type',
    pathCtrlPtTooltip: 'Drag control point to adjust curve properties',
    pick_stroke_paint_opacity: 'Pick a Stroke Paint and Opacity',
    pick_fill_paint_opacity: 'Pick a Fill Paint and Opacity',
    group_identify_label: 'Group identification label',
    export_type_label: 'Select an image type for export:'
  },
  properties: {
    id: 'Zmeniť ID elementu',
    fill_color: 'Zmeniť farbu výplne',
    stroke_color: 'Zmeniť farbu obrysu',
    stroke_style: 'Zmeniť štýl obrysu',
    stroke_width: 'Zmeniť hrúbku obrysu',
    pos_x: 'Zmeniť súradnicu X',
    pos_y: 'Zmeniť súradnicu Y',
    linecap_butt: 'Koniec čiary: presný',
    linecap_round: 'Koniec čiary: zaoblený',
    linecap_square: 'Koniec čiary: so štvorcovým presahom',
    linejoin_bevel: 'Napojenie čiar: skosené',
    linejoin_miter: 'Napojenie čiar: ostré',
    linejoin_round: 'Napojenie čiar: oblé',
    angle: 'Zmeniť uhol natočenia',
    blur: 'Zmeniť intenzitu rozmazania',
    opacity: 'Zmeniť prehľadnosť vybraných položiek',
    circle_cx: 'Zmeniť súradnicu X stredu kružnice',
    circle_cy: 'Zmeniť súradnicu Y stredu kružnice',
    circle_r: 'Zmeniť polomer kružnice',
    ellipse_cx: 'Zmeniť súradnicu X stredu elipsy',
    ellipse_cy: 'Zmeniť súradnicu Y stredu elipsy',
    ellipse_rx: 'Zmeniť polomer X elipsy',
    ellipse_ry: 'Zmeniť polomer Y elipsy',
    line_x1: 'Zmeniť počiatočnú súradnicu X čiary',
    line_x2: 'Zmeniť koncovú súradnicu X čiary',
    line_y1: 'Zmeniť počiatočnú súradnicu Y čiary',
    line_y2: 'Zmeniť koncovú súradnicu Y čiary',
    rect_height: 'Zmena výšku obdĺžnika',
    rect_width: 'Zmeniť šírku obdĺžnika',
    corner_radius: 'Zmeniť zaoblenie rohov obdĺžnika',
    image_width: 'Zmeniť šírku obrázka',
    image_height: 'Zmeniť výšku obrázka',
    image_url: 'Zmeniť URL',
    node_x: 'Zmeniť uzlu súradnicu X',
    node_y: 'Zmeniť uzlu súradnicu Y',
    seg_type: 'Zmeniť typ segmentu',
    straight_segments: 'Rovný',
    curve_segments: 'Krivka',
    text_contents: 'Zmeniť text',
    font_family_label: 'Font:',
    font_family: 'Zmeniť font',
    font_size: 'Zmeniť veľkosť písma',
    bold: 'Tučné',
    text_decoration_underline: 'Underline',
    text_decoration_linethrough: 'Line-Through',
    text_decoration_overline: 'Overline',
    italic: 'Kurzíva',
    text_anchor_start: 'Align the text in start',
    text_anchor_middle: 'Align the text in middle',
    text_anchor_end: 'Align the text in end',
    text_letter_spacing: 'Change the letter spacing',
    text_word_spacing: 'Change the word spacing',
    text_length: 'Lets you specify the width of the space into which the text will draw',
    text_length_adjust: 'Length adjust',
    text_length_adjust_spacing: 'Spacing',
    text_length_adjust_spacing_and_glyphs: 'Spacing & Glyphs',
    class: 'Element class',
    serif: 'Serif',
    sans_serif: 'Sans-serif',
    cursive: 'Cursive',
    fantasy: 'Fantasy',
    monospace: 'Monospace',
    courier: 'Courier',
    helvetica: 'Helvetica',
    times: 'times',
    prefs_and_content: 'Store preferences and SVG content locally',
    prefs_only: 'Only store preferences locally',
    no_prefs_or_content: 'Do not store my preferences or SVG content locally',
    jgraduate_pad: 'Pad',
    jgraduate_reflect: 'Reflect',
    jgraduate_repeat: 'Repeat'
  },
  tools: {
    main_menu: 'Hlavné menu',
    bkgnd_color_opac: 'Zmeniť farbu a priehľadnosť pozadia',
    connector_no_arrow: 'Spojnica bez šípok',
    fitToContent: 'Prispôsobiť obsahu',
    fit_to_all: 'Prisposobiť celému obsahu',
    fit_to_canvas: 'Prispôsobiť stránke',
    fit_to_layer_content: 'Prispôsobiť obsahu vrstvy',
    fit_to_sel: 'Prispôsobiť výberu',
    align_relative_to: 'Zarovnať relatívne k ...',
    relativeTo: 'vzhľadom k:',
    page: 'stránke',
    largest_object: 'najväčšiemu objektu',
    selected_objects: 'zvoleným objektom',
    smallest_object: 'najmenšiemu objektu',
    new_doc: 'Nový obrázok',
    open_doc: 'Otvoriť obrázok',
    export_img: 'Export',
    save_doc: 'Uložiť obrázok',
    import_doc: 'Import SVG',
    align_to_page: 'Zarovnať element na stránku',
    align_bottom: 'Zarovnať dole',
    align_center: 'Zarovnať na stred',
    align_left: 'Zarovnať doľava',
    align_middle: 'Zarovnať na stred',
    align_right: 'Zarovnať doprava',
    align_top: 'Zarovnať hore',
    mode_select: 'Výber',
    mode_fhpath: 'Ceruzka',
    mode_line: 'Čiara',
    mode_rect: 'Obdĺžnik',
    mode_square: 'Štvorec',
    mode_fhrect: 'Obdĺžnik voľnou rukou',
    mode_ellipse: 'Elipsa',
    mode_circle: 'Kružnica',
    mode_fhellipse: 'Elipsa voľnou rukou',
    mode_path: 'Krivka',
    mode_text: 'Text',
    mode_image: 'Obrázok',
    mode_zoom: 'Priblíženie',
    no_embed: 'POZNÁMKA: Tento obrázok nemôže byť vložený. Jeho zobrazenie bude závisieť na jeho ceste',
    undo: 'Späť',
    redo: 'Opakovať',
    tool_source: 'Upraviť SVG kód',
    wireframe_mode: 'Drôtový model',
    clone: 'Klonuj element(y)',
    del: 'Zmaž element(y)',
    group_elements: 'Zoskupiť elementy',
    make_link: 'Naviaž odkaz (hyper)link',
    set_link_url: 'Nastav odkaz URL (ak prázdny, odstráni sa)',
    to_path: 'Previesť na krivku',
    reorient_path: 'Zmeniť orientáciu krivky',
    ungroup: 'Zrušiť skupinu',
    docprops: 'Vlastnosti dokumentu',
    editor_homepage: 'SVG-Edit Home Page',
    move_bottom: 'Presunúť spodok',
    move_top: 'Presunúť na vrch',
    node_clone: 'Klonovať uzol',
    node_delete: 'Zmazať uzol',
    node_link: 'Prepojiť kontrolné body',
    add_subpath: 'Pridať ďalšiu súčasť krivky',
    openclose_path: 'Otvoriť/uzatvoriť súčasť krivky',
    source_save: 'Uložiť',
    cut: 'Vystrihnutie',
    copy: 'Kópia',
    paste: 'Vloženie',
    paste_in_place: 'Vloženie na pôvodnom mieste',
    delete: 'Zmazanie',
    group: 'Group',
    move_front: 'Vysuň navrch',
    move_up: 'Vysuň vpred',
    move_down: 'Zasuň na spodok',
    move_back: 'Zasuň dozadu',
    tool_unlink_use: 'Break link to reference element (make unique)',
    ellipse_circle_tool: 'Ellipse/Circle Tool',
    square_rect_tool: 'Square/Rect Tool',
    remember_this_choice: 'Remember this choice?',
    remember_this_choice_title: 'If you choose to opt out of storage while remembering this choice, the URL will change so as to avoid asking again.'
  },
  layers: {
    layer: 'Vrstva',
    layers: 'Vrstvy',
    del: 'Odstrániť vrstvu',
    move_down: 'Presunúť vrstvu dole',
    new: 'Nová vrstva',
    rename: 'Premenovať vrstvu',
    move_up: 'Presunúť vrstvu hore',
    dupe: 'Zduplikovať vrstvu',
    merge_down: 'Zlúčiť s vrstvou dole',
    merge_all: 'Zlúčiť všetko',
    move_elems_to: 'Presunúť elementy do:',
    move_selected: 'Presunúť vybrané elementy do inej vrstvy'
  },
  config: {
    image_props: 'Vlastnosti obrázka',
    doc_title: 'Titulok',
    doc_dims: 'Rozmery plátna',
    included_images: 'Vložené obrázky',
    image_opt_embed: 'Vložiť data (lokálne súbory)',
    image_opt_ref: 'Použiť referenciu na súbor',
    editor_prefs: 'Vlastnosti editora',
    language: 'Jazyk',
    background: 'Zmeniť pozadie',
    editor_img_url: 'Image URL',
    editor_bg_note: 'Poznámka: Pozadie nebude uložené spolu s obrázkom.',
    select_predefined: 'Vybrať preddefinovaný:',
    units_and_rulers: 'Jednotky & Pravítka',
    show_rulers: 'Ukáž pravítka',
    base_unit: 'Základné jednotky:',
    grid: 'Mriežka',
    snapping_onoff: 'Priväzovanie (do mriežky) zap/vyp',
    snapping_stepsize: 'Priväzovanie (do mriežky) veľkosť kroku:',
    grid_color: 'Grid color',
    done: 'Done',
    change_xxx_color: 'Change xxx color',
    pick_paint_opavity: 'Pick a {{newValue}} Paint and Opacity',
    open_color_picker: 'Click To Open Color Picker',
    jpicker_title: 'Drag Markers To Pick A Color',
    jpicker_new_color: 'new',
    jpicker_current_color: 'current',
    jpicker_tooltip_colors_new_color: 'New Color - Press &ldquo;OK&rdquo; To Commit',
    jpicker_tooltip_colors_current_color: 'Click To Revert To Original Color',
    jpicker_tooltip_buttons_ok: 'Commit To This Color Selection',
    jpicker_tooltip_buttons_cancel: 'Cancel And Revert To Original Color',
    jpicker_tooltip_hue_radio: 'Set To &ldquo;Hue&rdquo; Color Mode',
    jpicker_tooltip_hue_textbox: 'Enter A &ldquo;Hue&rdquo; Value (0-360&deg;)',
    jpicker_tooltip_saturation_radio: 'Set To &ldquo;Saturation&rdquo; Color Mode',
    jpicker_tooltip_saturation_textbox: 'Enter A &ldquo;Saturation&rdquo; Value (0-100%)',
    jpicker_tooltip_value_radio: 'Set To &ldquo;Value&rdquo; Color Mode',
    jpicker_tooltip_value_textbox: 'Enter A &ldquo;Value&rdquo; Value (0-100%)',
    jpicker_tooltip_red_radio: 'Set To &ldquo;Red&rdquo; Color Mode',
    jpicker_tooltip_red_textbox: 'Enter A &ldquo;Red&rdquo; Value (0-255)',
    jpicker_tooltip_green_radio: 'Set To &ldquo;Green&rdquo; Color Mode',
    jpicker_tooltip_green_textbox: 'Enter A &ldquo;Green&rdquo; Value (0-255)',
    jpicker_tooltip_blue_radio: 'Set To &ldquo;Blue&rdquo; Color Mode',
    jpicker_tooltip_blue_textbox: 'Enter A &ldquo;Blue&rdquo; Value (0-255)',
    jpicker_tooltip_alpha_radio: 'Set To &ldquo;Alpha&rdquo; Color Mode',
    jpicker_tooltip_alpha_textbox: 'Enter A &ldquo;Alpha&rdquo; Value (0-100)',
    jpicker_tooltip_hex_textbox: 'Enter A &ldquo;Hex&rdquo; Color Value (#000000-#ffffff)',
    jpicker_tooltip_hex_alpha: 'Enter A &ldquo;Alpha&rdquo; Value (#00-#ff)',
    jgraduate_solid_color: 'Solid Color',
    jgraduate_linear_gradient: 'Linear Gradient',
    jgraduate_radial_gradient: 'Radial Gradient',
    jgraduate_begin_point: 'Begin Point',
    jgraduate_enter_starting_x: 'Enter starting x value between 0.0 and 1.0',
    jgraduate_enter_starting_y: 'Enter starting y value between 0.0 and 1.0',
    jgraduate_end_point: 'End Point',
    jgraduate_enter_ending_x: 'Enter ending x value between 0.0 and 1.0',
    jgraduate_enter_ending_y: 'Enter ending y value between 0.0 and 1.0',
    jgraduate_center_point: 'Center Point',
    jgraduate_enter_value_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_value_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_focal_point: 'Focal Point',
    jgraduate_match_center: 'Match center:',
    jgraduate_enter_focal_x: 'Enter x value between 0.0 and 1.0',
    jgraduate_enter_focal_y: 'Enter y value between 0.0 and 1.0',
    jgraduate_spread_method: 'Spread method',
    jgraduate_radius: 'Radius:',
    jgraduate_set_radius: 'Click to set radius',
    jgraduate_ellip: 'Ellip:',
    jgraduate_set_ellip: 'Click to set Ellip',
    jgraduate_angle: 'Angle:',
    jgraduate_set_angle: 'Click to set Angle',
    jgraduate_deg: 'deg:',
    jgraduate_opac: 'Opac:',
    jgraduate_set_opac: 'Click to set Opac'
  },
  notification: {
    invalidAttrValGiven: 'Neplatná hodnota',
    noContentToFitTo: 'Vyberte oblasť na prispôsobenie',
    dupeLayerName: 'Vrstva s daným názvom už existuje!',
    enterUniqueLayerName: 'Zadajte jedinečný názov vrstvy',
    enterNewLayerName: 'Zadajte názov vrstvy',
    layerHasThatName: 'Vrstva už má zadaný tento názov',
    QmoveElemsToLayer: "Presunúť elementy do vrstvy '%s'?",
    QwantToClear: 'Naozaj chcete vymazať kresbu?\n(História bude taktiež vymazaná!)!',
    QwantToOpen: 'Chcete otvoriť nový súbor?\nTo však tiež vymaže Vašu UNDO knižnicu!',
    QerrorsRevertToSource: 'Chyba pri načítaní SVG dokumentu.\nVrátiť povodný SVG dokument?',
    QignoreSourceChanges: 'Ignorovať zmeny v SVG dokumente?',
    featNotSupported: 'Vlastnosť nie je podporovaná',
    enterNewImgURL: 'Zadajte nové URL obrázka',
    defsFailOnSave: 'POZNÁMKA: Kvôli chybe v prehliadači sa tento obrázok môže zobraziť nesprávne (napr. chýbajúce prechody či elementy). Po uložení sa zobrazí správne.',
    loadingImage: 'Nahrávam obrázok, prosím čakajte ...',
    saveFromBrowser: "Select 'Save As...' in your browser (possibly via file menu or right-click context-menu) to save this image as a {{type}} file.",
    noteTheseIssues: 'Môžu sa vyskytnúť nasledujúce problémy: ',
    unsavedChanges: 'Sú tu neuložené zmeny.',
    enterNewLinkURL: 'Zadajte nové URL odkazu (hyperlink)',
    errorLoadingSVG: 'Chyba: Nedajú sa načítať SVG data',
    URLLoadFail: 'Nemožno čítať z URL',
    retrieving: 'Retrieving \'%s\' ...',
    popupWindowBlocked: 'Popup window may be blocked by browser',
    exportNoBlur: 'Blurred elements will appear as un-blurred',
    exportNoforeignObject: 'foreignObject elements will not appear',
    exportNoDashArray: 'Strokes will appear filled',
    exportNoText: 'Text may not appear as expected',
    editorPreferencesMsg: 'By default and where supported, SVG-Edit can store your editor preferences and SVG content locally on your machine so you do not need to add these back each time you load SVG-Edit. If, for privacy reasons, you do not wish to store this information on your machine, you can change away from the default option below.',
    source_dialog_note: 'Copy the contents of this box into a text editor, then save the file with a .svg extension.'
  }
}
